
import React from 'react'
import Logo from '../../constants/logo'

function DashLooker() {
  return (
    <div className='app' style={{backgroundColor:'#f5f5f5'}}>
        <nav className='app__navbar'>
        <Logo/>
        </nav>
        <div className='app__container'>
            <div className='app__wrapper app__flex'>  
                
                <iframe title="dash-looker" width="100%" height="768px" src="https://lookerstudio.google.com/embed/reporting/08f2832f-4b44-4be0-9706-2c1fac051a03/page/ylPdD" frameborder="0" allowfullscreen></iframe>
            </div>
        </div>
        
    </div>
  )
}

export default DashLooker

